import { render, staticRenderFns } from "./FieldType25Configure.vue?vue&type=template&id=fa3885a0"
import script from "./FieldType25Configure.vue?vue&type=script&lang=js"
export * from "./FieldType25Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports